import { mapPlayerProfile } from './player-profile.mappers';
import type { ApiFetchPlayerProfilePort } from '~/handlers/ports/api-fetch-player-profile.port';
import type { PlayerProfile } from '~/types/player-profile';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoAuthHeaders } from '~/utils/apostatudo/get-apostatudo-auth-headers';

// GET /players/me — elegibilidade de aposta + nível VIP do jogador logado numa
// resposta só, pra o front resolver menu e badge sem encadear requests.
//
// Identidade segue a convenção das rotas públicas do core: `user_id` na query e
// o Bearer só pra barrar anônimo. Mesma dívida técnica do board (um token válido
// pode ler o perfil de outro user_id); a correção é a introspecção de token.
//
// O core memoiza a elegibilidade e só reconsulta o banco externo uma vez por
// minuto por jogador, então esta chamada é barata do lado dele — o que cara é a
// PRIMEIRA de um jogador nunca visto: ela REGISTRA o jogador e faz o round trip
// até a view do cactus (mediu-se 0,45s a 2,4s). Daí o timeout de 10s, igual ao do
// board.
export class ApostatudoApiFetchPlayerProfileAdapter
  implements ApiFetchPlayerProfilePort
{
  async handle({ userId }: { userId: number }): Promise<PlayerProfile> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(
      `${getApostatudoApiUrl()}/players/me?user_id=${userId}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...getApostatudoAuthHeaders(),
        },
        // Esta rota é pedida de novo a cada volta de foco e a cada abertura do
        // Clube Fidelidade, sempre no mesmo host: `keepalive` deixa o browser
        // reaproveitar a conexão em vez de pagar handshake a cada vez. Ganho
        // pequeno e de graça — o payload são três campos, então o custo da
        // chamada é quase todo ida e volta.
        keepalive: true,
        signal: controller.signal,
      },
    ).finally(() => clearTimeout(timeoutId));

    if (!response.ok) {
      throw new Error(`PlayerProfile failed: ${response.status}`);
    }

    return mapPlayerProfile(await response.json(), userId);
  }
}
